// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__Z6MmG","content":"RecentSearches_content__x7TCk"};